import { UserDatasetRefreshStatus, DatasetRefreshErrorDto } from 'src/app/services/api.services';
import { GenericAlertDialog, GenericAlertData, GenericAlertButton } from 'src/app/shared/dialogs';
import { distinctBy, escapeHtml, group } from 'src/app/shared/utils';
import { isDevEnvironment } from 'src/client-config';
import { UserDatasetValidationStateDialog, UserDatasetValidationStateDialogData } from './dialogs/userdataset-validation-state.dialog';
import { MatDialog } from '@angular/material/dialog';
import { UserDatasetLoadResult } from 'src/app/pbir/userDatasets/UserDatasetLoader';

export function openUserDatasetErrorDialog(dialog: MatDialog, loadResult: UserDatasetLoadResult) {
  let errorMessagePrefix = `<p>An unexpected error occurred while refreshing the dataset.</p>`;
  let errorMessageSuffix = `<p>Contact your administrator for more detail, citing '${loadResult.jobId ?? loadResult.userDatasetId}' as error reference.</p>`;

  if (loadResult.cancelled) {
    errorMessagePrefix = `<p>The dataset refresh has been cancelled.</p>`;
    errorMessageSuffix = ``;
  }

  const errorTitle = 'Alert';
  let errorDetail = '';

  let errorDtos: DatasetRefreshErrorDto[] = [];

  let parsedDto: any;

  if (loadResult.error) {
    try {
      parsedDto = JSON.parse(loadResult.error);
      if ('length' in parsedDto) {
        errorDtos.push(...parsedDto);
      }
      else {
        errorDtos.push(parsedDto);
      }

    }
    catch {
      parsedDto = null;
    }
  }

  if (errorDtos.find(e => e.error === 'Dataset Validation Failed')) {
    // INFO: Special case - see IN-3423
    dialog.open(UserDatasetValidationStateDialog, {
      width: '600px',
      data: <UserDatasetValidationStateDialogData>{
        userDatasetId: loadResult.userDatasetId,
        canSeeDetails: true
      }
    });

    return;
  }
  else {
    if (!isDevEnvironment())
      errorDtos = errorDtos.filter(e => e.userFriendly);

    const errorDtoByDataset = group(errorDtos, x => x.dataset);

    for (const { key, items } of errorDtoByDataset) {
      for (const errorDto of distinctBy(items, x => x.detail)) {
        errorDetail += escapeHtml(errorDto.detail) || '';
      }
    }

    errorDetail = errorDetail.trim();

    if (errorDetail.length)
      errorDetail = `<p>${errorDetail}</p>`;

    dialog.open(GenericAlertDialog, {
      width: '600px',
      data: <GenericAlertData>{
        title: errorTitle,
        content: [errorMessagePrefix, errorDetail, errorMessageSuffix].join(''),
        buttons: [GenericAlertButton.close]
      }
    });
  }
}

